import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { IxEmptyState } from '@siemens/ix-angular/standalone'
import { AuthService } from './auth.service'

@Component({
  selector: 'unauthenticated',
  imports: [IxEmptyState, TranslateModule],
  template: `
    <ix-empty-state
      class="state"
      icon="log-in"
      [header]="'LOGIN.UNAUTHENTICATED.TITLE' | translate"
      [subHeader]="'LOGIN.UNAUTHENTICATED.MESSAGE' | translate"
      [action]="'LOGIN.LOGIN_BUTTON' | translate"
      (actionClick)="onLoginClicked()" />
  `,
  styleUrl: './unauthenticated.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthenticatedComponent {
  readonly #authService = inject(AuthService)

  onLoginClicked() {
    this.#authService.login()
  }
}
